import {
  DIALOG_OPEN,
  DIALOG_SUBMIT,
  DIALOG_CANCEL
} from 'actions/dialog'

const pendingDialogs = {}

export default ({ dispatch }) => next => action => {
  // Let this action to drop to the store anyway
  const result = next(action)

  if (action.type === DIALOG_OPEN) {
    return new Promise((resolve, reject) => {
      pendingDialogs[action.id] = {resolve, reject}
    })
  }

  if (action.type === DIALOG_SUBMIT) {
    const dialog = pendingDialogs[action.id]
    if (dialog) {
      pendingDialogs[action.id].resolve()
      delete pendingDialogs[action.id]
    }
  }
  if (action.type === DIALOG_CANCEL) {
    const dialog = pendingDialogs[action.id]
    if (dialog) {
      pendingDialogs[action.id].reject()
      delete pendingDialogs[action.id]
    }
  }

  return result
}



